import LookupTableParameter from "views/logic/parameters/LookupTableParameter";
import LookupTableQueryParameterEdit from "components/lookup-table-parameters/LookupTableQueryParameterEdit";
import FilterAggregationFormContainer from "./FilterAggregationFormContainer";
import FilterAggregationForm from "./FilterAggregationForm";
import FilterAggregationSummary from "./FilterAggregationSummary";
const bindings = {
  eventDefinitionQueryParameterTypes: [
    {
      type: LookupTableParameter.type,
      title: "Lookup Table",
      fromJSON: LookupTableParameter.fromJSON.bind(LookupTableParameter),
      validate: (param) => ({
        lookupTable: !param.lookupTable ? "Cannot be empty" : void 0,
        key: !param.key ? "Cannot be empty" : void 0
      }),
      editComponent: LookupTableQueryParameterEdit
    }
  ],
  eventDefinitionTypes: [
    {
      type: "aggregation-v1",
      displayName: "Filter & Aggregation",
      sortOrder: 0,
      // Sort before conditions working on events
      description: "Create Events from log messages by filtering them and (optionally) aggregating their results to match a given condition. These Events can be used as input for a Correlation Rule.",
      formComponent: FilterAggregationFormContainer,
      summaryComponent: FilterAggregationSummary,
      defaultConfig: FilterAggregationForm.defaultConfig,
      useCondition: () => true
    }
  ]
};
export default bindings;
